module.exports = __webpack_public_path__ + "img/v2-redesign-roadshow-preview.8820ff58.png";